import { t } from "i18next";
import React, { ChangeEvent, FC, useCallback } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";

import Icons from "@app/assets/Icons";
import LoadingButton from "@app/components/Button";
import { Debounce } from "@app/utils/helpers";

import "./index.scss";

interface ViewUtilityHeaderProps {
    placeholder: string;
    btnLabel: string;
    onChange: (_event: React.ChangeEvent<HTMLSelectElement>) => void;
    onClick?: () => void;
    onSearch?: (_val: string) => void;
    secondaryBtnLabel?: string;
    onSecondaryClick?: () => void;
}

const ViewUtilityHeader: FC<ViewUtilityHeaderProps> = ({
    onChange,
    placeholder,
    btnLabel,
    onClick,
    onSearch,
    secondaryBtnLabel,
    onSecondaryClick,
}) => {
    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value;
        onSearch && onSearch(searchText);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleSearchChangeDebounce = useCallback(Debounce(handleSearchChange, 500), []);
    return (
        <Row className='viewHeader__utilityContainer' data-testid='utility-container'>
            {onClick && (
                <Col className='p-0 flex-grow-1 me-2'>
                    <LoadingButton
                        icon={<img src={Icons.PlusIcon} className='viewHeader__plusIcon' />}
                        label={btnLabel}
                        variant='add'
                        onClick={onClick}
                        btnClass='viewHeader__add-button'
                    />
                </Col>
            )}
            {secondaryBtnLabel && (
                <Col className='p-0 flex-grow-1'>
                    <LoadingButton
                        label={secondaryBtnLabel}
                        variant='add'
                        onClick={onSecondaryClick}
                        btnClass='viewHeader__add-button-secondary'
                    />
                </Col>
            )}
            <Col className='viewHeader__rowSelection flex-grow-1'>
                <div className='viewHeader__rowSelectionLabel'>{t("ROW_SELECTION.SHOW")}</div>
                <div>
                    <Form.Select size='sm' onChange={(event) => onChange(event)}>
                        <option value='10'>10 rows</option>
                        <option value='25'>25 rows</option>
                        <option value='50'>50 rows</option>
                        <option value='100'>100 rows</option>
                    </Form.Select>
                </div>
            </Col>

            <Col className='viewHeader__search flex-grow-1'>
                <InputGroup>
                    <Form.Control
                        placeholder={placeholder}
                        aria-label={placeholder}
                        aria-describedby='search-addon'
                        onChange={handleSearchChangeDebounce}
                    />
                </InputGroup>
            </Col>
        </Row>
    );
};

export default ViewUtilityHeader;
